import { render, staticRenderFns } from "./GaauHistory.vue?vue&type=template&id=c380e12c&"
import script from "./GaauHistory.vue?vue&type=script&lang=js&"
export * from "./GaauHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports